function padZero(num, min) {
    let i = Math.trunc(num);
    const array = [];
    while (i >= 10) {
        array.push(i % 10);
        i = Math.trunc(i / 10);
    }
    array.push(i);
    for (let j = array.length; j < min; j++) {
        array.push('0');
    }
    return array.reverse().join('');
}
export function formatTime(time) {
    const s = parseInt(`${time}`, 10);
    const m = s / 60;
    const h = m / 60;
    const hh = padZero(h, 2);
    const mm = padZero(m % 60, 2);
    const ss = padZero(s % 60, 2);
    return `${hh}:${mm}:${ss}`;
}
